


























import { DialogsModule } from "@/store/dialogs.module";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CustomDialog extends Vue {
  get dialog() {
    return DialogsModule.customDialog;
  }

  close() {
    DialogsModule.setCustomDialog({
      show: false,
      title: "",
      text: "",
    });
    this.$router.push("/contracts");
  }
}
